module.exports = __webpack_public_path__ + "static/media/pic6.dda53042.jpg";